module.exports = __webpack_public_path__ + "media/images/upload_youtube-07d5ebd4.png";